module.exports = __webpack_public_path__ + "img/advantage2_2@2x.e27a9f09.png";